import {combineReducers} from 'redux';

import * as actionTypes from './actionTypes';

const initialState = {
    uploading: false,
    currentFolder: {},
    currentFolderId: null,
    folderTree: [],
    draggingItem: false,
    uploadQueue: [],
    uploadingFile: null,
    uploadProgress: 0,
    uploadSpeed: 0,
    uploadTimeLeft: 99999999,
    trashItems: []
};

const trashItems = (state = initialState.trashItems, action) => {
    switch (action.type) {
        case actionTypes.SET_TRASH:
            return action.files;
        case actionTypes.ADD_FILE_TO_TRASH:
            return [...action.files, ...state];
        case actionTypes.REMOVE_FILE_FROM_TRASH:
            return [...state].filter(x => x.id !== action.fileId);
        case actionTypes.EDIT_FILE_TRASH_LOADING:
            const aux = [...state];
            const index = aux.findIndex(x => x.id === action.data.fileId);
            aux[index].loading = action.data.loading;
            return aux;
        case actionTypes.SET_ALL_TRASH_LOADING:
            return state.map(x => {
                return {...x, loading: true}
            });
        default:
            return state;

    }
}

const uploadQueue = (state = initialState.uploadQueue, action) => {
    switch (action.type) {
        case actionTypes.ADD_FILES_UPLOAD_QUEUE:
            const auxAdd = [...state];
            auxAdd.push(...action.files);
            return auxAdd;
        case actionTypes.SHIFT_FILE_UPLOAD_QUEUE:
            const auxShift = [...state];
            auxShift.shift();
            return auxShift;
        case actionTypes.REMOVE_FILE_UPLOAD_QUEUE:
            return [...state].filter(x => x.file.name !== action.fileName);
        default:
            return state;

    }
}

const draggingItem = (state = initialState.draggingItem, action) => {
    switch (action.type) {
        case actionTypes.DRAGGING_DRIVE_ITEM:
            return true;
        case actionTypes.FINISH_DRAGGING_ITEM:
            return false;
        default:
            return false;

    }
}

const uploading = (state = initialState.uploading, action) => {

    switch (action.type) {
        case actionTypes.UPLOADING_NEW_FILE:
            return true;
        case actionTypes.FINISH_UPLOADING_NEW_FILE:
            return false;
        default:
            return state;
    }

}

const uploadingFile = (state = initialState.uploadingFile, action) => {
    switch (action.type) {
        case actionTypes.SET_UPLOADING_FILE:
            return action.file;
        case actionTypes.FINISH_UPLOADING_NEW_FILE:
            return initialState.uploadingFile;
        default:
            return state;

    }
}

const uploadProgress = (state = initialState.uploadingFile, action) => {
    switch (action.type) {
        case actionTypes.SET_UPLOADING_FILE:
            return 0;
        case actionTypes.CHANGE_UPLOAD_PROGRESS:
            return action.progress;
        case actionTypes.FINISH_UPLOADING_NEW_FILE:
            return 0;
        default:
            return state;

    }
}

const uploadSpeed = (state = initialState.uploadSpeed, action) => {
    switch (action.type) {
        case actionTypes.SET_UPLOADING_FILE:
            return 0;
        case actionTypes.CHANGE_UPLOAD_SPEED:
            return action.speed;
        case actionTypes.FINISH_UPLOADING_NEW_FILE:
            return 0;
        default:
            return state;

    }
}

const uploadTimeLeft = (state = initialState.uploadTimeLeft, action) => {
    switch (action.type) {
        case actionTypes.SET_UPLOADING_FILE:
            return 0;
        case actionTypes.CHANGE_UPLOAD_TIME_LEFT:
            return action.timeLeft;
        case actionTypes.FINISH_UPLOADING_NEW_FILE:
            return 0;
        default:
            return state;

    }
}


const currentFolder = (state = initialState.currentFolder, action) => {

    switch (action.type) {
        case actionTypes.LOADING_FILES:
            return null;
        case actionTypes.CHANGED_FOLDER:
            return action.folder;
        case actionTypes.FOLDER_CREATED:
            return {
                ...state,
                folders: [...state.folders, action.folder].sort((a, b) => {
                    return a.folderName.localeCompare(b.folderName);
                })
            };
        case actionTypes.UPLOADED_NEW_FILE:
            if (state.files.some(x => x.id === action.newFile.id)) {
                const auxFiles = {
                    ...state,
                    files: state.files.filter((x) => action.newFile.id !== x.id),
                }
                return {
                    ...auxFiles,
                    files: [action.newFile, ...auxFiles.files]
                }
            }
            return {
                ...state,
                files: [action.newFile, ...state.files].sort((a, b) => {
                    const dateA = new Date(a.uploadDate);
                    const dateB = new Date(b.uploadDate);
                    return dateB.getTime() - dateA.getTime();
                })
            };
        case actionTypes.CHANGED_FILE_FOLDER:
            return {
                ...state,
                files: state.files.filter((x) => !action.files.some((y) => x.id === y.id)),
                folders: state.folders.filter((x) => !action.files.some((y) => x.id === y.id)),
            };
        default:
            return state;
    }
}

const currentFolderId = (state = initialState.currentFolderId, action) => {
    switch (action.type) {
        case actionTypes.CURRENT_FOLDER_CHANGED:
            return action.folderId;
        default:
            return state;
    }
}

const folderTree = (state = initialState.folderTree, action) => {
    switch (action.type) {
        case actionTypes.FOLDER_TREE_ADD:
            if (state.some(x => x.id === action.folder.id)) {
                return state;
            }
            return [...state, action.folder];
        case actionTypes.FOLDER_TREE_BACK:
            const aux = [...state];
            const index = aux.findIndex(x => x.id === action.folder.id);
            return aux.slice(0, index + 1);
        default:
            return state;
    }
}

const reducer = combineReducers({
    uploading,
    currentFolder,
    currentFolderId,
    folderTree,
    draggingItem,
    uploadQueue,
    uploadingFile,
    uploadProgress,
    uploadSpeed,
    uploadTimeLeft,
    trashItems
});

export default reducer;
